// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap';
import {whenReady, App} from "@odoo/owl";
import TirApp from "./App/app2";
import { translateFn_en, translateFn_hu } from "./App/translate";

if (!window.MabSearch) {
    window.MabSearch = window.MabSearch || true;
    whenReady(() => {
        const mab_decisions = document.querySelectorAll('.decision-search');
        if (mab_decisions.length) {
            window.MabSearch = [];
            // get cookie pll_language
            const language = document.cookie.split('; ').find(row => row.startsWith('pll_language='))?.split('=')[1] || 'hu';
            const translateFn = language === 'en' ? translateFn_en : translateFn_hu;
            mab_decisions.forEach(
                el => {
                    var app = new App(TirApp, {
                        dev: false,
                        env: {
                            baseUrl: el.getAttribute('data-base-url') || '/search/',
                            apiUrl: el.getAttribute('data-api-url') // || 'http://localhost:5000/api',
                        },
                        translateFn: translateFn,
                    });
                    app.mount(el).then(
                        () => {
                            console.log("App mounted");
                            el.style.display = "block";
                        },
                        (err) => {
                            console.error(err);
                        }
                    );
                    window.MabSearch.push(app);
                }
            )
        }
    })
}

